import React, { useEffect, Suspense } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from 'geniebook-ui/dist';
import useHideBottomNavbar from '@utils/helpers/useHideBottomNavbar';
import { subjectIdFromName } from '@utils/helpers/SubjectParser';
import {
  NavbarState,
  haveAccountSection,
  haveBottomSheet,
  isBottomSheetVisible,
  setNavbarWithTitleWithTopNavbar,
} from '@atom/navbarAtom';
import { BackgroundContainer } from '@assets/styles/background.style';
import { useAtomValue, useStore } from 'jotai';
import { useViewWidth } from '@utils/helpers/viewWidth';

const CustomWorksheet = React.lazy(() => import('geniesmart/CustomWorksheet'));
const breakpoint = require('geniebook-ui/dist/themes/breakpoint');
const CustomWorksheetPage = () => {
  useHideBottomNavbar();
  const navbarState = useAtomValue(NavbarState);
  const width = useViewWidth();
  const store = useStore();

  useEffect(() => {
    setNavbarWithTitleWithTopNavbar('Create Worksheet');
  });

  useEffect(() => {
    const isSmallScreen = width < breakpoint.lg;
    store.set(haveBottomSheet, isSmallScreen);
    store.set(haveAccountSection, !isSmallScreen);
  }, [width]);

  const toggleBottomSheet = (value: boolean) => {
    store.set(isBottomSheetVisible, value);
  };

  const { subjectId } = useParams();
  const navigate = useNavigate();

  const onNavigate = (navigation: string) => {
    navigate(navigation);
  };

  useEffect(() => {
    document.body.scrollTop = 0;
  }, []);

  return (
    <BackgroundContainer
      className={
        'h-[calc(100svh-68px)] max-lg:h-[calc(100svh-131px)] max-md:h-[calc(100svh-109px)]'
      }
    >
      <Container className={'max-lg:pt-6 lg:pt-10'}>
        <Suspense>
          <CustomWorksheet
            subjectSlug={subjectId ?? ''}
            subjectId={subjectIdFromName(subjectId ?? '')}
            onNavigation={onNavigate}
            isBottomSheetVisible={navbarState.isBottomSheetVisible}
            toggleBottomSheet={toggleBottomSheet}
          />
        </Suspense>
      </Container>
    </BackgroundContainer>
  );
};

export default CustomWorksheetPage;
